import React, { useEffect, useState, useRef } from "react";
import { Stack } from "@mantine/core";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getMasterTrades } from "app/state/ducks/master-trades/selectors";
import { MasterTradeParams } from "app/models/master-trade-params";
import DocumentTradeEntryPanel from "./document-trade-entry-panel";
import { useTradePageDeals } from "app/views/pages/trade-entry/detail-trade/use-trade-page-lookups";


export function DocumentTradeEntry() {
  const { tradeId } = useParams();
  const allMasterTrades = useSelector(getMasterTrades);
  const deals = useTradePageDeals();

  const [masterTrade, setMasterTrade] = useState<MasterTradeParams>();

  // The tab's records — the trade, its sub trades, attachments, signable
  // documents, funding-memo metadata, deliveries — are loaded by the page
  // shell before the tab renders (ADR_LOS-030 step 3: one request, one
  // statement), and re-read after each write.

  // Find Master Trade
  useEffect(() => {
    if (!tradeId || !allMasterTrades.length) return;
    const trade = allMasterTrades.find((trade) => trade.id === tradeId);
    setMasterTrade(trade);
  }, [tradeId, allMasterTrades]);

  // Use a ref flag to ensure the update happens only once
  const hasUpdatedMasterTrade = useRef(false);

  useEffect(() => {
    if (!masterTrade || !deals.length || hasUpdatedMasterTrade.current) return;

    const matchedDeal = deals.find(
      (deal) => deal.id === masterTrade.dealId?.id
    );
    if (!matchedDeal) return;

    setMasterTrade((prevMasterTrade) => {
      if (!prevMasterTrade) return undefined;

      // Check if the masterTrade already has the updated deal details
      if (
        prevMasterTrade.dealCusip === matchedDeal.cusip &&
        prevMasterTrade.dealName === matchedDeal.dealName &&
        prevMasterTrade.dealId?.id === matchedDeal.id
      ) {
        return prevMasterTrade;
      }

      // Set the flag to avoid future updates
      hasUpdatedMasterTrade.current = true;
      return {
        ...prevMasterTrade,
        dealCusip: matchedDeal.cusip ?? "",
        dealName: matchedDeal.dealName ?? "",
        dealId: { id: matchedDeal.id, admin: matchedDeal.accountManagementAdmin },
      };
    });
  }, [masterTrade, deals]);


  return (
    <Stack w="100%">
      <div className="stack-container" style={{ width: '100%' }}>
        {masterTrade && <DocumentTradeEntryPanel row={masterTrade} />}
      </div>
    </Stack>
  );
}
